import { DecimalPipe } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Chart, CategoryScale, LinearScale, LineController, LineElement, PointElement, Legend, registerables } from "chart.js";
import { WindowService } from "../../../core/core";

export interface LineChartOptions {
  yAxisTicksFormat: "none" | "money";
}
@Component({
  selector: "common-line-chart",
  templateUrl: "./line-chart.component.html",
  styleUrls: ["./line-chart.component.scss"],
})
export class LineChartComponent implements OnChanges, AfterViewInit, OnInit {
  @Input() chartType: "line" | "bar" = "line";
  @Input() data;
  @Input() options: LineChartOptions = {
    yAxisTicksFormat: "none",
  };
  @Input() displayY1: boolean = true;

  @ViewChild("chart") chartRef: ElementRef;
  chart: Chart;

  windowSize: string;

  constructor(private decimalPipe: DecimalPipe, private windowService: WindowService) {}

  ngOnInit(): void {
    this.windowSize = this.windowService.windowSize;
  }

  ngAfterViewInit(): void {
    const font = {
      family: "Circular Std",
      size: 16,
      weight: "lighter",
      color: "black",
    };

    Chart.register(CategoryScale, LinearScale, LineController, LineElement, PointElement, Legend, ...registerables);
    if (!this.chart) {
      this.chart = new Chart(this.chartRef.nativeElement, {
        type: this.chartType,
        data: this.data,
        options: {
          elements: {
            point: {
              radius: 0,
              hoverRadius: 0,
            },
            line: {
              borderWidth: 2,
            },
          },
          responsive: true,
          maintainAspectRatio: this.windowSize == "mobile" ? false : true,
          onResize: (t, a) => {
            // console.log(t);
            // console.log(a);
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
              labels: {
                usePointStyle: true,
                pointStyle: "rect",
                padding: 30,
                font,
              },
            },
          },
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              display: true,
              title: {
                display: false,
              },
              grid: { display: false }, // hide the grid liunes
              ticks: {
                font,
              },
            },
            y: {
              beginAtZero: true,
              display: true,
              suggestedMin: 0,
              title: {
                display: false,
              },
              ticks: {
                font,
                color: "#009688",
                callback: s => {
                  switch (this.options.yAxisTicksFormat) {
                    case "money":
                      return `$${this.decimalPipe.transform(s, "1.0-0")}`;
                  }
                  return s;
                },
              },
              //grace: 25, // add 25 above and below the datasets
            },
            y1: {
              display: this.displayY1,
              position: "right",
              title: {
                display: false,
              },
              ticks: {
                font,
                color: "#f53331",
                callback: s => {
                  switch (this.options.yAxisTicksFormat) {
                    case "money":
                      return `$${this.decimalPipe.transform(s, "1.0-0")}`;
                  }

                  return s;
                },
                count: 6,
              },
              grace: 25, // add 25 above and below the datasets
            },
          },
        },
      });
      window["chart"] = this.chart;
    } else {
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.chart) {
      return;
    }

    this.chart.data = this.data;
    this.chart.update();
  }
}
